<template>
  <el-popover trigger="click" placement="top">
    <table>
      <tr v-for="(item,j) in productRuleList" :key="j">
        <td style="text-align: left">
          <span v-html="item" />
        </td>
      </tr>
    </table>

    <span slot="reference" @click="validateProductRule" v-show="groupSubItemListVO.showRule">
      <!--<el-tag size="medium" ><i class="el-icon-error"></i></el-tag>-->
      <!--<i class="el-icon-error"></i>-->
      <!--<span style="height:10px;width:10px;background-image: url('../../icons/jiaoyan.png')"></span>-->
      <img src="../../icons/jiaoyan2.png" style="vertical-align:middle;margin-bottom: 2px;  height:21px; width:21px" alt="err">
    </span>
  </el-popover>
</template>

<script>
import api from '../../api';
export default {
  name: 'ProductRule',
  data () {
    return {
      productRuleList: []
    };
  },
  components: {},
  props: {
    groupSubItemListVO: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    validateProductRule () {
      // console.log("validateProductRule");
      // this.productRuleList=[456];
      api.getAddedValidateInfo(this.groupSubItemListVO).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.productRuleList = json.data;
        }
      }).catch(() => {
        this.$notify.error('网络异常！');
      });
    }
  }
};
</script>

<style scoped>
  .el-icon-error{
    font-size: 20px;
    color: red;
  }

</style>
